import { render, staticRenderFns } from "./TagTemplate.vue?vue&type=template&id=7cd4b110&scoped=true"
import script from "./TagTemplate.vue?vue&type=script&lang=js"
export * from "./TagTemplate.vue?vue&type=script&lang=js"
import style0 from "./TagTemplate.vue?vue&type=style&index=0&id=7cd4b110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd4b110",
  null
  
)

export default component.exports